import { FormationDetailProps } from '@/types/formation';

export const travailHauteurFormation: FormationDetailProps = {
  id: '22',
  title: 'Formation Travail en Hauteur',
  description: 'Acquérez les compétences nécessaires pour travailler en hauteur en toute sécurité, en maîtrisant les techniques de prévention des chutes et l\'utilisation des équipements de protection individuelle (EPI) adaptés.',
  duration: '14 heures (2 jours)',
  category: 'Sécurité',
  imageSrc: '/images/formations/harnaisfiche.webp',
  slug: 'travail-hauteur',
  reference: 'F-TH',
  price: 'Sur devis – nous contacter',
  
  // Détails supplémentaires
  objectives: [
    'Comprendre les risques liés au travail en hauteur',
    'Maîtriser les techniques de prévention des chutes',
    'Savoir utiliser les équipements de protection individuelle (EPI)',
    'Connaître la réglementation en vigueur',
    'Savoir organiser et sécuriser une zone de travail en hauteur'
  ],
  
  targetAudience: 'Toute personne amenée à effectuer des travaux en hauteur (nettoyage, maintenance, BTP, etc.)',
  
  prerequisites: [
    'Aucun prérequis technique particulier',
    'Être en bonne condition physique (certificat médical de non-contre-indication recommandé)'
  ],
  
  program: [
    {
      title: 'Théorie',
      items: [
        'Réglementation et cadre légal',
        'Analyse des risques spécifiques',
        'Moyens de protection collective et individuelle',
        'Organisation du travail en hauteur'
      ]
    },
    {
      title: 'Pratique',
      items: [
        'Vérification des EPI',
        'Techniques d\'accès et de déplacement en hauteur',
        'Mise en place de protections collectives',
        'Exercices pratiques sur simulateur'
      ]
    }
  ],
  
  evaluationMethods: [
    'Évaluation théorique (QCM)',
    'Mise en situation pratique',
    'Démonstration des gestes techniques'
  ],
  
  certification: 'Attestation de formation Travail en Hauteur - Valable 3 ans',
  
  pedagogicalMethods: [
    'Apports théoriques',
    'Échanges et retours d\'expérience',
    'Démonstrations pratiques',
    'Mises en situation réelles'
  ],
  
  accessibilityCriteria: 'Accessible aux personnes en situation de handicap (nous consulter pour aménagements spécifiques)',
  
  registrationProcess: [
    'Inscription en ligne ou par téléphone',
    'Règlement demandé à l\'inscription',
    'Dossier d\'inscription à compléter et à nous retourner',
    'Convocation envoyée sous 48h'
  ],
  
  intervenant: 'Formateur certifié en prévention des risques professionnels, spécialisé dans le travail en hauteur avec plus de 10 ans d\'expérience sur le terrain.',
  
  formatterInfo: {
    name: 'SDPSI Formation',
    phone: '01 23 45 67 89',
    email: 'contact@sdpsi-formations.fr',
    website: 'www.sdpsi-formations.fr'
  }
};

export default travailHauteurFormation;
